<template>
  <div class="py-4 overflow-y-auto max-h-[calc(100vh-100px)]">
    <div v-if="parentPage.showEmployeeStats" class="mb-4">
      <h3 class="text-lg font-bold text-gray-800 mb-4">Employee Attendance Status</h3>
      <div class="flex flex-col gap-3">
        <div @click="parentPage.navToEmployee" class="cursor-pointer">
          <ReusableBox
            :number="parentPage.statsData?.userClockInStats?.totalEmployees"
            :content="`Total Active Employees`"
            color="bg-indigo-500 dark:bg-[#4B5B9F]"
            class="py-6"
          />
        </div>
        <div class="cursor-pointer" @click="parentPage.navToClockInEmployee">
          <ReusableBox
            :number="parentPage.statsData?.userClockInStats?.checkedInMembers"
            :content="parentPage.isComplaintsEnabled ? 'Present' : 'Clocked-in'"
            color="bg-teal-500 dark:bg-[#2A9D8F]"
            class="py-6"
          />
        </div>
        <div class="cursor-pointer" @click="parentPage.navToNonClockInEmployee">
          <ReusableBox
            :number="parentPage.statsData?.userClockInStats?.notCheckedInMembers"
            :content="parentPage.isComplaintsEnabled ? 'Absent' : 'Not Clocked-in'"
            color="bg-red-500 dark:bg-[#D9534F]"
            class="py-6"
          />
        </div>
      </div>
    </div>
    <div v-else class="flex flex-col items-center justify-center py-12 text-gray-500">
      <v-icon size="48" class="mb-2 text-gray-300">mdi-calendar-remove</v-icon>
      <span class="text-sm">No attendance stats configured.</span>
    </div>
  </div>
</template>

<script>
import ReusableBox from '@/components/ReusableBox.vue'

export default {
  name: 'DashboardPage_mobile',
  components: {
    ReusableBox
  },
  inject: ['parentPage']
}
</script>
